import RaceDisplaySimple from './RaceDisplaySimple';

export default RaceDisplaySimple;
export { RaceDisplaySimple };
